/**
 * 根据地址栏参数 year 的不同，显示不同的页面内容。
 */

import { byId, getQueryString, byClass, setStyle, removeElement, show, isMobile } from './utils'
import { symbols, mainSymbols, giftsImages, yourDescriptions } from './constants'

const years = parseInt(getQueryString('year') || 40)

/**
 * 用年数替换页面上的 token
 */
function replaceToken () {
  const tokenDivs = document.getElementsByClassName('has-token')
  for (let i = 0; i < tokenDivs.length; i++) {
    const tokenDivEl = tokenDivs[i]
    tokenDivEl.innerHTML = tokenDivEl.innerHTML.replace(/\{token\}/, years)
  }
}

/**
 * 当 years = 1 时显示 “year” 而不是 “years”
 */
function replaceYearsWord () {
  if (years === 1) {
    const celebratingTitleRightEl = byClass('celebrating-title-right')
    celebratingTitleRightEl.innerHTML = celebratingTitleRightEl.innerHTML.replace(/years/g, 'year')
  }
}

/**
 * 移除不需要的页面
 */
function removePageForYear () {
  if (years < 1) {
    removeElement(byId('yearbook'))
    byId('celebrating').classList.add('welcome')
  }
  if (years < 3) {
    removeElement(byId('keepsake-cubes').parentElement)
  }
  if (years < 5) {
    removeElement(byId('gifts').parentElement)
    removeElement(byClass('swiper-button-next'))
    removeElement(byClass('swiper-button-prev'))
    removeElement(byClass('yearbook-description-two'))
  } else {
    removeElement(byClass('yearbook-description-one'))
  }
}

/**
 * 更新 “Your” 页面文本
 */
function updateYourDescription () {
  let description = ''
  for (const year in yourDescriptions) {
    if (years >= parseInt(year)) {
      description = yourDescriptions[year]
    } else {
      break
    }
  }
  byClass('your-description').innerHTML = `<div>${description}</div>`
  if (years === 0) byClass('your-title').innerHTML = 'Welcome symbol'
}

/**
 * 更新 Your 页面图片
 */
function updateYourYearSymbol () {
  const mainSymbol = getYourYearSymbol()
  setStyle(byClass('your-image-img'), {
    'background-image': `url('${mainSymbol.img}')`
  })
  byClass('your-image-label').innerHTML = mainSymbol.label
}

function getYourYearSymbol() {
  let mainSymbol = ''
  for (const year in mainSymbols) {
    if (years >= parseInt(year)) {
      mainSymbol = mainSymbols[year]
    } else {
      break
    }
  }
  return mainSymbol
}

function getYourYearImages() {
  return [getYourYearSymbol().img]
}

/**
 * 更新三列图页面
 */
function updateWearImages () {
  let imageOrder = [[0, 1, 2, 0, 1, 2], [3, 5, 3, 5, 3, 5], [2, 4, 0, 2, 4, 0]]
  const wearImages = getWearImages()
  if (isMobile()) {
    imageOrder = [[0, 5, 6, 11, 12, 17, 18, 23], [1, 4, 7, 10, 13, 16, 19, 22], [3, 2, 9, 8, 15, 14, 21, 20]]
  }
  const imagesColumnsEl = byClass('wear-images-columns').children
  for (let i = 0; i < imagesColumnsEl.length; i++) {
    const imagesColumnEl = imagesColumnsEl[i]
    for (let j = 0; j < imageOrder[i].length; j++) {
      appendImage(wearImages[imageOrder[i][j]], imagesColumnEl)
    }
  }
}

function getWearImages() {
  let wearImages = []
  if (isMobile()) {
    const symbolEntries = Object.entries(JSON.parse(JSON.stringify(symbols)))
    for (let i = 0; i < 4; i++) {
      const images = symbolEntries.splice(i, 1)[0][1]
      wearImages = wearImages.concat(images.map(image => image.back))
    }
  } else {
    let currentSymbols = []
    for (const year in symbols) {
      if (years >= parseInt(year)) {
        currentSymbols = symbols[year]
      } else {
        break
      }
    }
    wearImages = currentSymbols.map(s => s.back)
  }
  return wearImages
}

function appendImage (imageUrl, container) {
  const imgEl = document.createElement('img')
  imgEl.src = imageUrl
  container.appendChild(imgEl)
}

/**
 * 更新 Gifts 图片
 */
function updateGifts () {
  if (years < 5) return
  const giftsImagesEl = byClass('gifts-images').children
  const giftsUrls = getGiftsImages()
  for (let i = 0; i < giftsImagesEl.length; i++) {
    const imgEl = giftsImagesEl[i].children[0]
    imgEl.src = giftsUrls[i]
  }
}

function getGiftsImages() {
  let giftsUrls = []
  for (const year in giftsImages) {
    if (years >= parseInt(year)) {
      giftsUrls = giftsImages[year]
    } else {
      break
    }
  }
  return giftsUrls
}

/**
 * 导航栏透明
 */
function showNavbarOverlay () {
  if (getQueryString('overlay')) {
    show(byClass('navbar-overlay'))
  }
}

function switchMilestone () {
  const previousMilestoneLink = byClass('milestone-previous')
  const nextMilestoneLink = byClass('milestone-next')
  const milestones = Object.keys(symbols)
  const currentMilestoneIndex = milestones.findIndex((i) => parseInt(i) === years)
  const previousMilestone = currentMilestoneIndex > 0 ? milestones[currentMilestoneIndex - 1] : null
  const nextMilestone = currentMilestoneIndex < milestones.length ? milestones[currentMilestoneIndex + 1] : null
  if (previousMilestoneLink && previousMilestone) {
    previousMilestoneLink.href = `?year=${previousMilestone}`
    previousMilestoneLink.classList.remove('__disabled')
  }
  if (nextMilestoneLink && nextMilestone) {
    nextMilestoneLink.href = `?year=${nextMilestone}`
    nextMilestoneLink.classList.remove('__disabled')
  }
}

function handleMilestone () {
  showNavbarOverlay()
  removePageForYear()
  replaceYearsWord()
  replaceToken()
  updateYourDescription()
  updateYourYearSymbol()
  updateWearImages()
  updateGifts()
  switchMilestone()
}

export {
  handleMilestone,
  getYourYearImages,
  getWearImages,
  getGiftsImages
}
